import React from "react";
import { connect } from "react-redux";
import { actUserLogout } from "../../../actions";
import classes from "./dashboard.module.scss";
import DesktopDashboard from "./DesktopDashboard";
import MobileDashboard from "./MobileDashboard";

const Dashboard = ({ profile_data, actUserLogout }) => {
  return (
    <div className={classes.dashboard_home}>
      <DesktopDashboard />
      <MobileDashboard
        profile_data={profile_data}
        actUserLogout={actUserLogout}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile_data: state.data.profile_data,
});

export default connect(mapStateToProps, { actUserLogout })(Dashboard);
